// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609300504/js/" + chunkId + "." + {"44":"3a547fca","225":"de7766eb","481":"40124c99","486":"28b76919","770":"35c8545e"}[chunkId] + ".0.8804360675396748.chunk.js";
};